export default __webpack_public_path__ + "static/media/CAPWEB-Liquidaciones.5771f26c.pdf";